var map = {
	"./color-d.svg": 1603,
	"./color-e.svg": 1156,
	"./color-g.svg": 997,
	"./color-r.svg": 1157,
	"./color-s.svg": 1604,
	"./color-w.svg": 998,
	"./color-x.svg": 1158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1306;